<template>
  <v-card :loading="showLoading" class="back-to-previous-page mb-6">
    <v-card-title class="cursor-pointer" @click="returnBack">
      <div class="d-flex align-center w-full">
        <v-icon>{{ backButtonIcon }}</v-icon>
        <span class="ml-1">{{ backRouteText }}</span>
      </div>
    </v-card-title>
  </v-card>
</template>

<script>
import { mdiArrowLeftBoldCircleOutline } from '@mdi/js';
import router from '@/router';

export default {
  props: {
    backRouteText: {
      type: String,
      required: true,
    },
    backRouteName: {
      type: String,
      required: false,
    },
    backRouteParams: {
      type: Object,
      required: false,
    },
    showLoading: {
      type: Boolean,
      required: false,
    }
  },
  setup(props) {
    const returnBack = () => props.backRouteName ?
      router.push({ name: props.backRouteName, params: props.backRouteParams }) :
      router.back();

    return {
      backButtonIcon: mdiArrowLeftBoldCircleOutline,
      returnBack,
    };
  },
};
</script>
